import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getInternalPortalAnnouncements } from "../api/api";
// import LayoutBottom from "../Components/Layout/LayoutBottom";
// import LayoutTop from "../Components/Layout/LayoutTop";
import AnnouncementSliderComponent from "../Components/Sliders/AnnouncementSliderComponent";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { Card } from "react-bootstrap";

function InitiativesPage() {
  const { i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    "HomeSliderData",
    () =>
      getInternalPortalAnnouncements({
        limit: 20,
        table: "initiatives",
        language: i18n.language,
      })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  if (isLoading) return <div></div>;

  if (error) return <div></div>;

  return (
    <InnerPageLayout>
      <Card className="mb-4">
      <Card.Header> {i18n.t('initiatives')}</Card.Header>

        <Card.Body>
          <AnnouncementSliderComponent slides={data.data} />
        </Card.Body>
      </Card>
    </InnerPageLayout>
  );
}

export default InitiativesPage;
